// source: ResponseCode.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proto.ResponseCodeEnum', null, global);
/**
 * @enum {number}
 */
proto.proto.ResponseCodeEnum = {
  OK: 0,
  INVALID_TRANSACTION: 1,
  PAYER_ACCOUNT_NOT_FOUND: 2,
  INVALID_NODE_ACCOUNT: 3,
  TRANSACTION_EXPIRED: 4,
  INVALID_TRANSACTION_START: 5,
  INVALID_TRANSACTION_DURATION: 6,
  INVALID_SIGNATURE: 7,
  MEMO_TOO_LONG: 8,
  INSUFFICIENT_TX_FEE: 9,
  INSUFFICIENT_PAYER_BALANCE: 10,
  DUPLICATE_TRANSACTION: 11,
  BUSY: 12,
  NOT_SUPPORTED: 13,
  INVALID_FILE_ID: 14,
  INVALID_ACCOUNT_ID: 15,
  INVALID_CONTRACT_ID: 16,
  INVALID_TRANSACTION_ID: 17,
  RECEIPT_NOT_FOUND: 18,
  RECORD_NOT_FOUND: 19,
  INVALID_SOLIDITY_ID: 20,
  UNKNOWN: 21,
  SUCCESS: 22,
  FAIL_INVALID: 23,
  FAIL_FEE: 24,
  FAIL_BALANCE: 25,
  KEY_REQUIRED: 26,
  BAD_ENCODING: 27,
  INSUFFICIENT_ACCOUNT_BALANCE: 28,
  INVALID_SOLIDITY_ADDRESS: 29,
  INSUFFICIENT_GAS: 30,
  CONTRACT_SIZE_LIMIT_EXCEEDED: 31,
  LOCAL_CALL_MODIFICATION_EXCEPTION: 32,
  CONTRACT_REVERT_EXECUTED: 33,
  CONTRACT_EXECUTION_EXCEPTION: 34,
  INVALID_RECEIVING_NODE_ACCOUNT: 35,
  MISSING_QUERY_HEADER: 36,
  ACCOUNT_UPDATE_FAILED: 37,
  INVALID_KEY_ENCODING: 38,
  NULL_SOLIDITY_ADDRESS: 39,
  CONTRACT_UPDATE_FAILED: 40,
  INVALID_QUERY_HEADER: 41,
  INVALID_FEE_SUBMITTED: 42,
  INVALID_PAYER_SIGNATURE: 43,
  KEY_NOT_PROVIDED: 44,
  INVALID_EXPIRATION_TIME: 45,
  NO_WACL_KEY: 46,
  FILE_CONTENT_EMPTY: 47,
  INVALID_ACCOUNT_AMOUNTS: 48,
  EMPTY_TRANSACTION_BODY: 49,
  INVALID_TRANSACTION_BODY: 50,
  INVALID_SIGNATURE_TYPE_MISMATCHING_KEY: 51,
  INVALID_SIGNATURE_COUNT_MISMATCHING_KEY: 52,
  EMPTY_LIVE_HASH_BODY: 53,
  EMPTY_LIVE_HASH: 54,
  EMPTY_LIVE_HASH_KEYS: 55,
  INVALID_LIVE_HASH_SIZE: 56,
  EMPTY_QUERY_BODY: 57,
  EMPTY_LIVE_HASH_QUERY: 58,
  LIVE_HASH_NOT_FOUND: 59,
  ACCOUNT_ID_DOES_NOT_EXIST: 60,
  LIVE_HASH_ALREADY_EXISTS: 61,
  INVALID_FILE_WACL: 62,
  SERIALIZATION_FAILED: 63,
  TRANSACTION_OVERSIZE: 64,
  TRANSACTION_TOO_MANY_LAYERS: 65,
  CONTRACT_DELETED: 66,
  PLATFORM_NOT_ACTIVE: 67,
  KEY_PREFIX_MISMATCH: 68,
  PLATFORM_TRANSACTION_NOT_CREATED: 69,
  INVALID_RENEWAL_PERIOD: 70,
  INVALID_PAYER_ACCOUNT_ID: 71,
  ACCOUNT_DELETED: 72,
  FILE_DELETED: 73,
  ACCOUNT_REPEATED_IN_ACCOUNT_AMOUNTS: 74,
  SETTING_NEGATIVE_ACCOUNT_BALANCE: 75,
  OBTAINER_REQUIRED: 76,
  OBTAINER_SAME_CONTRACT_ID: 77,
  OBTAINER_DOES_NOT_EXIST: 78,
  MODIFYING_IMMUTABLE_CONTRACT: 79,
  FILE_SYSTEM_EXCEPTION: 80,
  AUTORENEW_DURATION_NOT_IN_RANGE: 81,
  ERROR_DECODING_BYTESTRING: 82,
  CONTRACT_FILE_EMPTY: 83,
  CONTRACT_BYTECODE_EMPTY: 84,
  INVALID_INITIAL_BALANCE: 85,
  INVALID_RECEIVE_RECORD_THRESHOLD: 86,
  INVALID_SEND_RECORD_THRESHOLD: 87,
  ACCOUNT_IS_NOT_GENESIS_ACCOUNT: 88,
  PAYER_ACCOUNT_UNAUTHORIZED: 89,
  INVALID_FREEZE_TRANSACTION_BODY: 90,
  FREEZE_TRANSACTION_BODY_NOT_FOUND: 91,
  TRANSFER_LIST_SIZE_LIMIT_EXCEEDED: 92,
  RESULT_SIZE_LIMIT_EXCEEDED: 93,
  NOT_SPECIAL_ACCOUNT: 94,
  CONTRACT_NEGATIVE_GAS: 95,
  CONTRACT_NEGATIVE_VALUE: 96,
  INVALID_FEE_FILE: 97,
  INVALID_EXCHANGE_RATE_FILE: 98,
  INSUFFICIENT_LOCAL_CALL_GAS: 99,
  ENTITY_NOT_ALLOWED_TO_DELETE: 100,
  AUTHORIZATION_FAILED: 101,
  FILE_UPLOADED_PROTO_INVALID: 102,
  FILE_UPLOADED_PROTO_NOT_SAVED_TO_DISK: 103,
  FEE_SCHEDULE_FILE_PART_UPLOADED: 104,
  EXCHANGE_RATE_CHANGE_LIMIT_EXCEEDED: 105,
  MAX_CONTRACT_STORAGE_EXCEEDED: 106,
  TRANSFER_ACCOUNT_SAME_AS_DELETE_ACCOUNT: 107,
  TOTAL_LEDGER_BALANCE_INVALID: 108,
  EXPIRATION_REDUCTION_NOT_ALLOWED: 110,
  MAX_GAS_LIMIT_EXCEEDED: 111,
  MAX_FILE_SIZE_EXCEEDED: 112,
  INVALID_TOPIC_ID: 150,
  INVALID_ADMIN_KEY: 155,
  INVALID_SUBMIT_KEY: 156,
  UNAUTHORIZED: 157,
  INVALID_TOPIC_MESSAGE: 158,
  INVALID_AUTORENEW_ACCOUNT: 159,
  AUTORENEW_ACCOUNT_NOT_ALLOWED: 160,
  TOPIC_EXPIRED: 162,
  INVALID_CHUNK_NUMBER: 163,
  INVALID_CHUNK_TRANSACTION_ID: 164,
  ACCOUNT_FROZEN_FOR_TOKEN: 165,
  TOKENS_PER_ACCOUNT_LIMIT_EXCEEDED: 166,
  INVALID_TOKEN_ID: 167,
  INVALID_TOKEN_DECIMALS: 168,
  INVALID_TOKEN_INITIAL_SUPPLY: 169,
  INVALID_TREASURY_ACCOUNT_FOR_TOKEN: 170,
  INVALID_TOKEN_SYMBOL: 171,
  TOKEN_HAS_NO_FREEZE_KEY: 172,
  TRANSFERS_NOT_ZERO_SUM_FOR_TOKEN: 173,
  MISSING_TOKEN_SYMBOL: 174,
  TOKEN_SYMBOL_TOO_LONG: 175,
  ACCOUNT_KYC_NOT_GRANTED_FOR_TOKEN: 176,
  TOKEN_HAS_NO_KYC_KEY: 177,
  INSUFFICIENT_TOKEN_BALANCE: 178,
  TOKEN_WAS_DELETED: 179,
  TOKEN_HAS_NO_SUPPLY_KEY: 180,
  TOKEN_HAS_NO_WIPE_KEY: 181,
  INVALID_TOKEN_MINT_AMOUNT: 182,
  INVALID_TOKEN_BURN_AMOUNT: 183,
  TOKEN_NOT_ASSOCIATED_TO_ACCOUNT: 184,
  CANNOT_WIPE_TOKEN_TREASURY_ACCOUNT: 185,
  INVALID_KYC_KEY: 186,
  INVALID_WIPE_KEY: 187,
  INVALID_FREEZE_KEY: 188,
  INVALID_SUPPLY_KEY: 189,
  MISSING_TOKEN_NAME: 190,
  TOKEN_NAME_TOO_LONG: 191,
  INVALID_WIPING_AMOUNT: 192,
  TOKEN_IS_IMMUTABLE: 193,
  TOKEN_ALREADY_ASSOCIATED_TO_ACCOUNT: 194,
  TRANSACTION_REQUIRES_ZERO_TOKEN_BALANCES: 195,
  ACCOUNT_IS_TREASURY: 196,
  TOKEN_ID_REPEATED_IN_TOKEN_LIST: 197,
  TOKEN_TRANSFER_LIST_SIZE_LIMIT_EXCEEDED: 198,
  EMPTY_TOKEN_TRANSFER_BODY: 199,
  EMPTY_TOKEN_TRANSFER_ACCOUNT_AMOUNTS: 200
};

goog.object.extend(exports, proto.proto);
